export function getSearchTerm(value) {
	const term = Array.isArray(value) ? value.at(-1) : value;
	return typeof term === 'string' ? term : '';
}
